import { render, staticRenderFns } from "./custom_form.vue?vue&type=template&id=25b43bed&scoped=true"
import script from "./custom_form.vue?vue&type=script&lang=js"
export * from "./custom_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b43bed",
  null
  
)

export default component.exports